import Icon from 'veui/components/Icon'
import { IconDatabase } from 'dls-icons-vue'

Icon.register('database', IconDatabase)
